import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../login-service';
@Component({
    selector: 'message-app',
    templateUrl: 'message.component.html',
    providers:[LoginService]
    // styleUrls: ['message.component.scss']
})

export class MessageComponent implements OnInit {
  url:string;
  tempColGroups=[];
    chatRoomsByUsers: any;
    tempchatRoomByUsers:any;
    tempChatMessages: any;
    chatMessagesByUsers: any;
    chatGroupMessagesByUsers
    ChatID: string;
    tempChatRooms: any;
    message:string;
    receiverUserID:string;
    senderUserID:string;
  tempChatGroups: any;
  chatGrouplist: any;
  userID: any;
  chatuserGrouplist: any;
  groupsLists: any;
  groupopenchat: any;
  IsGroup: boolean=false;
  ridlist: any;
  searchText:string;
  tempgrp=[];
  tempgrpByUsers=[];
  tabType: string;
  GroupID: any;
  lastmessage:any=[];
  groupUsers: any[];
  viewgrpInfo:boolean=false;
  groupUsersList: any;
  tempUsersList: any;
  leavegrpUser: any;
  usertype:string;
  ichatUser:any;
    constructor(private loginService:LoginService) { 
        this.senderUserID=localStorage.getItem('USERID');
        this.usertype=localStorage.getItem('userType');
    }

    ngOnInit() {
        this.GetChatRooms();
        this.userID=localStorage.getItem('USERID');
        this.Getchatgroup();
        // this.url="http://localhost:25396/";
        this.url=this.loginService.imageURL;
this.GetUsers();
        // this.Getchatusergroup();
     }
     GetUsers(){
      this.loginService.GetUsers(this.usertype).subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.tempUsersList=JSON.parse(JSON.stringify(data));
      });
    }
     Searchtext(){
       this.tempgrpByUsers=[];
       this.tempchatRoomByUsers=[];
this.FilterGroupsByUsers();
this.FilterChatByUsers();
     }
     FilterGroupsByUsers(){
      this.tempgrpByUsers = this.tempgrp;

    let tempCompany = this.tempgrp.filter(
      (item) => {
        return (
          (item.name !== null && item.name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
        );
      }

    );
    this.tempgrpByUsers = tempCompany;


     }
     FilterChatByUsers(){
      this.tempchatRoomByUsers = this.chatRoomsByUsers;
    
          let tempCompany = this.chatRoomsByUsers.filter(
            (item) => {
              return (
                (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
                (item.user_name1 !== null && item.user_name1.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
              );
            }
      
          );
          this.tempchatRoomByUsers = tempCompany;
         
     }
     groupInfo(g){
      this.groupUsers=[];
   
      this.Getchatusergroup();
      this.viewgrpInfo=true;
    
      this.groupUsersList=this.tempChatGroups.filter(x=>x.groupid==g.groupid);
     
      for(var i=0;i<this.groupUsersList.length;i++){
        this.groupUsers.push(this.tempUsersList.filter(x=>x.id==this.groupUsersList[i].userid ));
      
      }
      this.groupUsers.push(this.tempUsersList.filter(x=>x.id==g.userid ));
      
    }
    cancelgrpinfo(){
      this.viewgrpInfo=false;
      
    }
    leavegroup(g){
     
      this.leavegrpUser=this.tempChatGroups.filter(x=>x.userid==this.senderUserID && x.groupid==g.groupid);
    
this.Getchatgroup();
      event.stopPropagation();
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to leave this group' ,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.delete(this.leavegrpUser[0].id);//
        } else if (result.dismiss === Swal.DismissReason.cancel) {
    
        }
      })
    
    }
    
    delete(ID) {
      const json={
        id:ID
      }
      this.loginService.DeletechatuserGroup(json).subscribe(data => {
       
         Swal.fire("You have left the group successfully")
        setTimeout(() => {
          this.message = "";
        }, 1000);
        this.Getchatgroup();
      
      })
    
      }

     UserDetails(row){
       this.tabType="ichat";
      this.viewgrpInfo=false;
      this.GetChatRooms();
       this.IsGroup=false;
       this.ichatUser=row;
         this.receiverUserID=row.userid;
         this.ChatID=row.chatid;
         this.loginService.GetChatMessages().subscribe(data=>{
          data = JSON.parse(data['_body']);
          this.tempChatMessages=JSON.parse(JSON.stringify(data));

         let filterMessages=this.tempChatMessages.filter(x=>x.chatid==row.chatid && x.chatid!==0);
         if(filterMessages.length>0){
             this.chatMessagesByUsers=filterMessages;
         }
         else{
            this.chatMessagesByUsers=[];
         }
        });
     }
  GetChatRooms(){
    this.chatRoomsByUsers=[];
    this.chatMessagesByUsers=[];
  
    this.tempChatRooms=[];
    this.loginService.GetChatRooms().subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.tempChatRooms=JSON.parse(JSON.stringify(data));

      let filterchtroom=this.tempChatRooms.filter(x=>x.receiveruserid.toString()==this.senderUserID );
      console.log(filterchtroom)
      if(filterchtroom.length>0){
        this.chatRoomsByUsers=filterchtroom;
        this.tempchatRoomByUsers=filterchtroom;
      }
      else{
        this.chatRoomsByUsers=[];
        this.tempchatRoomByUsers=[];
      }
    
      
      this.loginService.GetChatMessages().subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.tempChatMessages=JSON.parse(JSON.stringify(data));

        for(let i=0;i<this.tempchatRoomByUsers.length;i++){
          let filterMessages=this.tempChatMessages.filter(x=>x.chatid.toString()==this.tempchatRoomByUsers[i].chatid.toString() );
          var length1=filterMessages.length-1;
        
          this.lastmessage.push(filterMessages[length1].message);
          }

      })
    })
  }
  Getchatgroup(){
    this.loginService.GetchatGroup().subscribe(data=>{
       data = JSON.parse(data['_body']);
       this.chatGrouplist=JSON.parse(JSON.stringify(data));


 this.loginService.GetchatuserGroup().subscribe(data=>{
  data = JSON.parse(data['_body']);
  
  this.tempChatGroups=JSON.parse(JSON.stringify(data));

  let filterChats=this.tempChatGroups.filter(x=>x.userid==this.userID && x.groupid!==0);
  this.chatuserGrouplist=filterChats;
 
  for(var i=0;i<this.chatuserGrouplist.length;i++){
    
    this.groupsLists=this.chatGrouplist.filter(x=>x.id===this.chatuserGrouplist[i].groupid);
 
   if(this.groupsLists.length>0)
  this.tempgrp.push({
    name:this.groupsLists[0].name,
    groupid:this.groupsLists[0].id,
    userid:this.groupsLists[0].userid,
    Profile:this.groupsLists[0].Profile,
  })
  this.tempgrpByUsers=this.tempgrp;

}

  
})
    })
}

Opengroupchat(g){
  this.tabType="gchat";
  this.viewgrpInfo=false;
  this.GetChatRooms();
  this.loginService.GetChatMessages().subscribe(data=>{
    data = JSON.parse(data['_body']);
    this.tempChatMessages=JSON.parse(JSON.stringify(data));
  this.IsGroup=true;
  this.groupopenchat=g;

  this.GroupID=g.groupid;
  this.ridlist=this.chatuserGrouplist.filter(x=>x.groupid===g.groupid)

  let groupmsgs=this.tempChatMessages.filter(x=>x.groupid==g.groupid )
  
         if(groupmsgs.length>0){
             this.chatGroupMessagesByUsers=groupmsgs;
         }
         else{
            this.chatGroupMessagesByUsers=[];
         }
         
  });
  
}

Getchatusergroup(){
 
}


sendNotification(message:string){
  const json={
    id:0,
  name:'New Message',
  description:message,
  userid:this.senderUserID,
  receiveruserid:this.receiverUserID,
  type:'message',
  typeid:0,
  createdby:'Admin',
  updatedby:'Admin',
  IsSender:0
  }

  this.loginService.SaveNotifications(json).subscribe(data=>{

  });

}
    SaveMessages(row){
      
if(this.IsGroup){
this.ChatID='0';

const json={
  chatid:this.ChatID,
message:this.message,
groupid:row.groupid,
senderuserid:this.senderUserID,
receiveruserid:row.userid,
createdbyparam:'Admin',
updatedbyparam:'Admin',
IsSender:0
}

this.loginService.SaveChatMessages(json).subscribe(data=>{
  
  this.Opengroupchat(row);
 
this.sendNotification(this.message);
  this.message="";

})




}
else{

        const json={
          chatid:this.ChatID,
        message:this.message,
        groupid:0,
        senderuserid:this.senderUserID,
        receiveruserid:this.receiverUserID,
        createdbyparam:'Admin',
        updatedbyparam:'Admin',
        IsSender:0
        }
        
        this.loginService.SaveChatMessages(json).subscribe(data=>{
        
this.UserDetails(row);
         this.GetChatRooms();
         this.sendNotification(this.message);
          this.message="";
        
        })
      }
    }
}
